let a = "just a test bro";
a; //?

a.includes("just");

1 + 23; //?
